'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var InputSelect = require('../InputSelect/InputSelect.js');

var getOptions = function (minTime, maxTime, step) {
    var currentTime = moment(minTime, 'HH:mm');
    var end = moment(maxTime, 'HH:mm');
    var endEpoch = end.unix();
    var createMenuItem = function (time) { return ({
        value: time.format('HH:mm'),
        display: time.format('h:mm A'),
    }); };
    var options = [createMenuItem(currentTime)];
    while (currentTime.unix() < endEpoch) {
        currentTime.add(step, 's');
        options.push(createMenuItem(currentTime));
    }
    return options;
};
var TimeInputSelect = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.disableClearable, disableClearable = _b === void 0 ? false : _b, id = props.id, _c = props.maxTime, maxTime = _c === void 0 ? '23:00' : _c, _d = props.minTime, minTime = _d === void 0 ? '00:00' : _d, onChange = props.onChange, _e = props.step, step = _e === void 0 ? 3600 : _e, _f = props.placeholder, placeholder = _f === void 0 ? '' : _f, _g = props.defaultValue, defaultValue = _g === void 0 ? undefined : _g;
    var defaultMenuItem = defaultValue
        ? { display: moment(defaultValue, 'HH:mm').format('h:mm A'), value: defaultValue }
        : undefined;
    return (React__default.createElement(InputSelect, { disableClearable: disableClearable, disabled: disabled, id: id, reporter: onChange, options: getOptions(minTime, maxTime, step), placeholder: placeholder, defaultValue: defaultMenuItem }));
};

module.exports = TimeInputSelect;
